import classes from "./Testimonials.module.css";

const DEFAULT_TESTIMONIALS = [];

function Stars({ rating = 0 }) {
  const safeRating = Math.max(0, Math.min(5, Number(rating)));

  return (
    <div
      className={classes.stars}
      role="img"
      aria-label={`${safeRating} out of 5 stars`}
    >
      {Array.from({ length: 5 }, (_, index) => (
        <span
          key={index}
          className={
            index < safeRating ? classes.starFilled : classes.starEmpty
          }
          aria-hidden="true"
        >
          ★
        </span>
      ))}
    </div>
  );
}

function getInitials(name = "") {
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join("");
}

export default function Testimonials({
  testimonials = DEFAULT_TESTIMONIALS,
  title = "Reviews by the Company Trusted by Professionals",
  description = "See why healthcare professionals trust MITSI to support better workflows, faster results, and improved patient care.",
  eyebrow = "TESTIMONIALS",
}) {
  if (!Array.isArray(testimonials) || !testimonials.length) {
    return null;
  }

  const sliderItems = [...testimonials, ...testimonials];

  return (
    <section className={classes.section} aria-labelledby="testimonials-title">
      <div className={classes.backgroundShape} aria-hidden="true" />

      <div className={classes.container}>
        <div className={classes.introColumn}>
          <span className={classes.eyebrow}>
            {eyebrow}
          </span>

          <h2 id="testimonials-title" className={classes.heading}>
            {title}
          </h2>

          <p className={classes.description}>
            {description}
          </p>

          <div className={classes.rating}>
            <strong className={classes.ratingValue}>4.8</strong>

            <div className={classes.ratingInfo}>
              <Stars rating={5} />
              <span className={classes.ratingLabel}>
                Average professional rating
              </span>
            </div>
          </div>
        </div>

        <div className={classes.sliderColumn}>
          <div className={classes.sliderShell}>
            <div className={classes.sliderTrack}>
              {sliderItems.map((item, index) => (
                <article
                  key={`${item.id ?? item.name}-${index}`}
                  className={classes.card}
                  aria-hidden={index >= testimonials.length}
                >
                  <div className={classes.cardHeader}>
                    <div className={classes.profile}>
                      <div className={classes.avatar} aria-hidden="true">
                        {getInitials(item.name)}
                      </div>

                      <div className={classes.meta}>
                        <h3 className={classes.name}>{item.name}</h3>
                        <p className={classes.position}>{item.position}</p>
                      </div>
                    </div>

                    <span className={classes.quote} aria-hidden="true">
                      “
                    </span>
                  </div>

                  <Stars rating={item.stars} />

                  <p className={classes.review}>{item.review}</p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
